const baseUrl = window.location.host;

export async function handleResponse(response){
  switch(true){
    case (response.status === 401) : handle401(await response.json()); break;
    case (response.status === 403) : handle403(); break;
    case (response.ok) : return true;
    default : return false;
  }
}

async function handle401(error){
  switch(true){
    case(error.Error === "Login Failed") :  window.location = `https://${baseUrl}/Error/LoginFail?description=${error.ErrorDescription}`; console.log('login failed'); return true;
    case(error.Error === "Registration Failed") :  window.location = `https://${baseUrl}/Error/RegistrationFailure?description=${error.ErrorDescription}`; return true;
    default : window.location = `https://${baseUrl}/Error/AccessDenied?description=${error.ErrorDescription}`; return true;
  }
}

async function handle403(response){
  window.location = `https://${baseUrl}/Error/AccessDenied`;
  return true;
}